import { SVLabeledText } from '@/components/core';
import { BankApplicationThirdPartyProcessorStatus } from '@/types/bankApplications';
import { getThirdPartyProcessorStatusString } from '@/utils/bankAccountApplications';
import { Card, Typography } from '@mui/material';

type BankApplicationStaffNotesProps = {
  thirdPartyProcessorStatus: BankApplicationThirdPartyProcessorStatus;
};

export default function BankApplicationStaffNotes({
  thirdPartyProcessorStatus,
}: BankApplicationStaffNotesProps) {
  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Staff Notes
      </Typography>
      <SVLabeledText
        label="Third Party Processor Status"
        text={getThirdPartyProcessorStatusString(thirdPartyProcessorStatus)}
      />
    </Card>
  );
}
